module.exports = __webpack_public_path__ + "static/media/About-Auto.b2c6bd7c.png";